import { Space } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import { ProcedureDossierType } from 'common/schema/Procedure';
import React from 'react';
import { IRequest } from 'common/schema/request/Request';
import { ISODate } from 'client/ui/display/date/ISODate';

export interface IRequestProcedureInfoBoxProps {
  request: IRequest;
}

export function RequestProcedureInfo(props: IRequestProcedureInfoBoxProps) {
  const { request } = props;

  return (
    <>
      <Space direction="vertical" size={12} style={{ marginTop: '16px' }}>
        <Paragraph className="request-sent-title">
          <Text type="secondary">Titolo Domanda:</Text>
          <Title level={3} style={{ marginTop: '0' }}>
            {request.procedure.title}
          </Title>
        </Paragraph>
        <Paragraph>
          <Text type="secondary">Autore: </Text>
          <Text strong>
            <Text strong>
              {request.citizen?.fullName ??
                `${request.authorName} ${request.authorFamilyName}`}
            </Text>
          </Text>
        </Paragraph>
        <Paragraph>
          <Text type="secondary">Data e Ora Invio: </Text>
          <Text strong>
            <ISODate date={request.sentAt} format={'DD/MM/YYYY HH:mm'} />
          </Text>
        </Paragraph>
        <Paragraph>
          <Text type="secondary">Codice Invio: </Text>
          <Text strong>{request.code}</Text>
        </Paragraph>
        {request.procedure.dossierType === ProcedureDossierType.Each && (
          <Paragraph>
            <Text type="secondary">Numero Fascicolo: </Text>
            <Text strong>
              {request.dossierCode ?? request.procedure.dossierNumber ?? 'N.A.'}
            </Text>
          </Paragraph>
        )}
        {request.protocolSignature && (
          <Paragraph>
            <Text type="secondary">Segnatura Protocollo: </Text>
            <Text strong>{request.protocolSignature}</Text>
          </Paragraph>
        )}
      </Space>
    </>
  );
}
